import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import NhanVayApi from "service/nhanVayApi";
import { formatNumber } from "utils/currencyFormat";

export const FileDinhKem = ({ nhanvayId }) => {
  const dataInit = {
    List: [],
  };
  const [dataLichSu, UpdateDataLichSu] = useState(dataInit);
  const DanhSachLichSu = (page) => {
    NhanVayApi.getFileDinhKemNhanVay(nhanvayId).then((response) => {
      UpdateDataLichSu({
        ...dataLichSu,
        List: response.data.List,
      });
    });
  };

  React.useEffect(() => {
    DanhSachLichSu(1);
  }, []);
  //End fix height tab

  return (
    <>
      <div style={{ paddingTop: 15 }}>
        {dataLichSu.List.map((item, index) => (
          <div className="col-sm-5">
            <a href={item.Url} target="_blank" download>
              {item.FileName}
            </a>
          </div>
        ))}
      </div>
    </>
  );
};
